import ReactSelect from "react-select";
import { getCountries, getCountryCallingCode } from "react-phone-number-input/input";

export const CountrySelect = ({ value, onChange, labels, isOnlyPanama }) => {
    const arrayCountries = getCountries();

    const options = arrayCountries.map(country => {
        return {
            value: country,
            label: `${labels[country]}`,
            image: `https://purecatamphetamine.github.io/country-flag-icons/3x2/${country}.svg`,
            code: country ? `+${getCountryCallingCode(country)}` : "",
        };
    });

    return (
        <ReactSelect
            value={value}
            options={options}
            isSearchable={false}
            onChange={onChange}
            components={{
                Option: CustomOption,
            }}
            formatOptionLabel={FormatOptionLabel}
        />
    );
};

const CustomOption = ({ innerProps, label, data }) => (
    <div {...innerProps}>
        <img src={data.image} alt={label} style={{ marginRight: "8px", width: "20px", height: "20px" }} />
        {label}
    </div>
);

const FormatOptionLabel = ({ label, image, value }) => (
    <div className="content-select">
        <img src={image} alt={label} style={{ marginRight: "8px", width: "20px", height: "20px" }} />+
        {getCountryCallingCode(value)}
    </div>
);
